import { useTranslation } from 'react-i18next'
import { useChatbotFlow } from '../chatbot.provider'
import { ConnectingNodeButton } from './connecting-node-button.component'
import { AddingNodeButton } from './adding-node-button.component'
import { NodeAddedActions } from './node-added-actions.component'

type TChatbotNodeBooleanResponseProps = {
  id: string
  showActions: boolean
}

export function ChatbotNodeBooleanResponse({ id, showActions }: Readonly<TChatbotNodeBooleanResponseProps>) {
  const { t } = useTranslation()
  const { addNodeWithConditionalConnection, edges, nodes } = useChatbotFlow()
  const currentNode = nodes.find((n) => n.id === id)

  const handleAddConditionalNode = (conditionKey: string) => (e: React.MouseEvent) => {
    e.stopPropagation()
    addNodeWithConditionalConnection(id, conditionKey)
  }

  const hasYesEdge = edges.some((edge) => edge.source === id && edge.sourceHandle === 'yes')
  const hasNoEdge = edges.some((edge) => edge.source === id && edge.sourceHandle === 'no')
  const isYesEdgeSelected = edges.some(
    (edge) => edge.selected && edge.source === id && edge.sourceHandle === 'yes',
  )
  const isNoEdgeSelected = edges.some(
    (edge) => edge.selected && edge.source === id && edge.sourceHandle === 'no',
  )

  return (
    <>
      <div className="c-flex c-flex-row c-gap-2 c-p-2 c-border-t c-border-gray-200">
        <div className="c-flex-1 c-border c-border-grey-500 c-rounded c-p-3 c-relative c-h-auto c-pb-5">
          <div className="c-text-xs c-font-semibold c-text-center">
            {t('pages.configuration.followups.chatbot.node-editor.yes')}
          </div>
          <NodeAddedActions currentNode={currentNode} conditionKey="yes" />
          <div className="c-absolute c-bottom-[-14px] c-left-0 c-right-0 c-flex c-justify-center c-gap-2">
            <ConnectingNodeButton
              handleId="yes"
              isConnectable={!hasYesEdge}
              isConnected={hasYesEdge}
              isPartOfSelectedEdge={isYesEdgeSelected}
              showIcon={showActions}
            />
            {showActions && !hasYesEdge && <AddingNodeButton onClick={handleAddConditionalNode('yes')} />}
          </div>
        </div>

        <div className="c-flex-1 c-border c-border-grey-500 c-rounded c-p-3 c-relative c-h-auto c-pb-5">
          <div className="c-text-xs c-font-semibold c-text-center">
            {t('pages.configuration.followups.chatbot.node-editor.no')}
          </div>
          <NodeAddedActions currentNode={currentNode} conditionKey="no" />
          <div className="c-absolute c-bottom-[-14px] c-left-0 c-right-0 c-flex c-justify-center c-gap-2">
            <ConnectingNodeButton
              handleId="no"
              isConnectable={!hasNoEdge}
              isConnected={hasNoEdge}
              isPartOfSelectedEdge={isNoEdgeSelected}
              showIcon={showActions}
            />
            {showActions && !hasNoEdge && <AddingNodeButton onClick={handleAddConditionalNode('no')} />}
          </div>
        </div>
      </div>
    </>
  )
}
